import '../../section-specific/babynames/baby-names';
import MainVue from '../../main-vue';

new MainVue({
    el: '#app',
    data: function () {
        return {
            name: "Baby Names"
        }
    }
});